"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: #fff;\n    padding: 10px 16px;\n    font-size: 14px;\n    text-transform: uppercase;\n    font-weight: bold;\n    line-height: 1.33;\n    display: inline-block;\n    margin-bottom: 0;\n    text-align: center;\n    touch-action: manipulation;\n    cursor: pointer;\n    border: 1px solid transparent;\n    white-space: nowrap;\n    user-select: none;\n    &:hover {\n        opacity: 0.9;\n    }\n    &:focus {\n        outline: none;\n    }\n    &[disabled] {\n        box-shadow: none;\n        opacity: .55;\n        pointer-events: none;\n        cursor: not-allowed;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Button = _styledComponents["default"].button(_templateObject(), function (_ref) {
  var bg = _ref.bg;
  return bg || '#f54d2e';
});

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(Button, props, props.children);
};

exports["default"] = _default;